<template>
<div>
    <div v-if="card && card.pspTokenId" :class="$vuetify.breakpoint.mdAndUp ? 'd-flex align-center' : ''">
        <div class="profile__container--content__payment-methods--cards-container d-flex align-center mb-5">

            <v-card width="250px" height="148px" outlined class="profile__container--content__payment-methods--cards-container__card d-flex justify-space-between flex-column pa-5 pt-7">
                <div class="d-flex justify-space-between align-center">
                    <p class="mb-0 font-weight-medium">**** **** **** {{card.metadata.masked_pan.split('XXXXXX')[1]}}</p>
                    <v-btn
                        elevation="0"
                        fab
                        small
                        color="primary"
                        outlined
                        @click="showDialog = true"
                    >
                        <v-icon color="primary" >fxt-trash</v-icon>
                    </v-btn>
                </div>
                <div class="d-flex justify-space-between align-center">
                    <p v-if="!card.isExpired" class="mb-0">{{card.metadata.expiry_date}}</p>
                    <img :src="card.metadata.brand === 'MasterCard' ? mastercardLogo : visaLogo">
                </div>
            </v-card>
        </div>
        <v-btn
            class="font-weight-bold secondary-font text-none px-8"
            :class="$vuetify.breakpoint.mdAndUp ? 'ml-5' : ''"
            color="primary"
            rounded
            outlined
            @click="changeCard(card.pspTokenId)"
        >
            Bytt kort
        </v-btn>
        <common-dialog
            v-if="showDialog"
            :show="showDialog" 
            title="Vil du slette kortet?" 
            icon="fxt-warning" 
            buttonTextConfirm="Slett kort" 
            @closeDialog="showDialog = false"
            @confirmAction="deleteCard(card.pspTokenId)"
            :layout="layout"
        >
            <p>Vil du slette VISA Kort {{card.metadata.masked_pan}}</p>
            <p>Sletter du dette kortet må du legge inn kortinformasjon på nytt.</p>
        </common-dialog>
    </div>
    <div v-else>
        <v-btn 
            class="text-none px-4" 
            color="primary"
            rounded
            outlined
            elevation="0"
            @click="addCard()"
        >
            <div class="d-flex">
                <div>Legg til kort</div>
                <v-icon class="pl-2" size="22">fxt-plus</v-icon>
            </div>
        </v-btn>
    </div>
    <div class="d-flex align-center">
        <span class="font-weight-bold pb-1 mr-5">Bruk som standard betalingsmåte</span>
        <v-switch
            color="primary"
            v-model="model"
            readonly
            @click="$emit('update', 0)"
        ></v-switch>
    </div>
</div>
</template>

<script>
import { CommonDialog } from '../../../../Common/CommonComponents'
import ProfileSvc from '../../../../../services/profile-svc';

let profileSvc = null;
export default {
    components: { CommonDialog },
    props: {
        model: {
            required: false,
            default: 100,
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    data() {
        return {
            visaLogo: require('../../../../../assets/img/visa-logo.png'),
            mastercardLogo: require('../../../../../assets/img//mastercard-logo.png'),
            showDialog: false,
            card: {}
        }
      },
    methods: {
        async deleteCard(tokenId) {
            this.card = await profileSvc.DeletePaymentToken(tokenId)
            if (!(this.card && this.card.pspTokenId)) {
                this.$store.commit('payment/setPaymentTokenId', null)
                profileSvc.emitSnackbar({
                    message: `Ditt kort har blitt fjernet.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
            } else {
                profileSvc.emitSnackbar({
                    message: `Noe gikk galt når vi forsøkte å fjerne ditt kort.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
            }
        },
        async changeCard(previousTokenId) {
            const wp = window.open(
                process.env.VUE_APP_CHECKOUT_WINDOW_URL,
                '_blank', 'toolbar=yes,scrollbars=yes,top=0,left=0,width=400,height=600'
            );
            await profileSvc.CreatePaymentToken().then((res) => {
                if (res) {
                    this.openSaveCreditCardWindow(res.checkoutUrl, wp, previousTokenId)
                }
            })
        },
        async addCard() {
            const wp = window.open(
                process.env.VUE_APP_CHECKOUT_WINDOW_URL,
                '_blank', 'toolbar=yes,scrollbars=yes,top=0,left=0,width=400,height=600'
            );
            await profileSvc.CreatePaymentToken().then((res) => {
                if (res) {
                    this.openSaveCreditCardWindow(res.checkoutUrl, wp)
                }
            })
        },
        async responseSwitch(status, previousTokenId, wp) {
            switch (status) {
                case 'SessionPaymentAuthorized':
                    if (previousTokenId) {
                        let card = await profileSvc.DeletePaymentToken(previousTokenId).then(async function() {
                            let i = 0;
                            let card = await new Promise(resolve => {
                                const timer = setInterval(async function () {
                                    let res = await profileSvc.GetPaymentToken();
                                    if (i >= 5 || (res && res.pspTokenId)) {
                                        clearInterval(timer);
                                        resolve(res)
                                        return res
                                    } else {
                                        i++;
                                    }
                                }, 1000);
                            })
                            wp.close();
                            return card || {}
                        });
                        return card || {}
                    } else {
                        let i = 0;
                        let card = await new Promise(resolve => {
                            const timer = setInterval(async function () {
                                let res = await profileSvc.GetPaymentToken();
                                if (i >= 5 || (res && res.pspTokenId)) {
                                    clearInterval(timer);
                                    resolve(res)
                                    return res
                                } else {
                                    i++;
                                }
                            }, 1000);
                        })
                        wp.close();
                        return card || {}
                    }
                case 'SessionCancel':
                    wp.close();
                    return {};
                case 'SessionPaymentError':
                case '':
                    wp.close();
                    return {};
                default:
                    return {}
            }
        },
        async openSaveCreditCardWindow(url, wp, previousTokenId = undefined) {
            wp.location.href = url;

            window.addEventListener('message', async (event) => {
                if (!(event.origin === process.env.VUE_APP_CHECKOUT_WINDOW_URL || event.origin === process.env.VUE_APP_FIXIT_PROFILE_URL)) {
                    return; 
                }

                const messageData = event.data;
                var card = await this.responseSwitch(messageData.paymentStatus, previousTokenId, wp)
                this.card = card
                if (card && card.pspTokenId) {
                    this.$store.commit('payment/setPaymentTokenId', card.pspTokenId)
                    profileSvc.emitSnackbar({
                    message: `Ditt kort har blitt lagret.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'info'
                })
                } else {
                    profileSvc.emitSnackbar({
                    message: `Noe gikk galt ved lagring av ditt kort.`, 
                    visible: true, 
                    duration: 5000, 
                    state: 'error'
                })
                }
            });
            /**
             * Handle when a user closes the payment window
             */
            const timer = setInterval(function () {
                if (wp && wp.closed) {
                    clearInterval(timer);
                    window.removeEventListener('message', () => {
                        return;
                    });
                    wp?.close();
                    
                }
            }, 1000);
        }
    },
    async mounted() {
        profileSvc = await ProfileSvc(this.$axios);
        this.card = await profileSvc.GetPaymentToken()
    }
}
</script>